import React from 'react';
import SpaceLike from '../components/Space';
import QrCode from './qr-code';
import styled from 'styled-components';
import useMediaQuery from '../hooks/useMediaQuery';
import {
  Text,
  TextAlignment,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';

const StyledText = styled(Text)`
  color: white;
  margin-bottom: 24px;
`;

const MobileOnlyScreen = () => {
  const {isMobile} = useMediaQuery();

  return (
    <SpaceLike
      direction="vertical"
      customStyles={{
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'scroll',
        paddingTop: '24px',
        gap: 0,
        paddingBottom: 'calc(50px + env(safe-area-inset-bottom))',
        overflowX: 'hidden',
        marginTop: 'auto',
        marginBottom: 'auto',
        height: '100%',
      }}
      width={'100%'}
      size={isMobile ? 24 : 48}
    >
      <QrCode
        scale={0.5}
        value={window.location.href}
        fgColor="#ffffff"
        bgColor="rgb(0, 83, 200)"
      />
      <StyledText
        appearance={TokenTextAppearance.copy200}
        textAlign={TextAlignment.center}
      >
        This is a mobile experience. <br /> Please scan the QR code to continue.
      </StyledText>
    </SpaceLike>
  );
};

export default MobileOnlyScreen;
